import api from './http';
import { ValidateRequest, ValidateResponse } from './types';

export async function validateBillingOrigin(request: ValidateRequest): Promise<ValidateResponse> {
  const { data } = await api.post('/api/v1/validate', request);
  return data;
}
